// Copyright (c) 2023 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { MANUAL_TIME_ACTIVITY } from "../../../app/localStorageKeys"
import { ActivityTypeOption, generateActivityOptions } from "../activities"

export type StorageReader = () => Observable<ActivityTypeOption>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(MANUAL_TIME_ACTIVITY)
    const storedActivity = data && JSON.parse(data)
    if (storedActivity !== null && generateActivityOptions().some(option => option.value === storedActivity.value)) {
      return of(storedActivity)
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadActivity = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.loadActivityFromStorage.match),
      mergeMap(_ => load().pipe(
        map(Slice.setInputActivity),
        catchError(_ => of(Actions.loadActivityFromStorageFailed())),
      )),
    )

export default loadActivity(load)
